<template>
  <div class="gender-selection-container">
    <h3 class="text-center mb-1 title">{{ $t('Gender') }}</h3>

    <b-row class="justify-content-center align-items-stretch">
      <!-- Female Option -->
      <b-col
          cols="6"
          md="5"
          class="d-flex justify-content-center gender-option-col"
      >
        <div
            :class="['gender-card', { 'selected': selectedGender === 'female' }]"
            @click="selectGender('female')"
        >
          <div class="gender-label">{{ $t('Female') }}</div>
          <b-img
              :src="require('@/assets/images/auth/female-avatar2.png')"
              alt="Female"
              class="gender-image"
              fluid
          />
        </div>
      </b-col>

      <!-- Male Option -->
      <b-col
          cols="6"
          md="5"
          class="d-flex justify-content-center gender-option-col"
      >
        <div
            :class="['gender-card', { 'selected': selectedGender === 'male' }]"
            @click="selectGender('male')"
        >
          <div class="gender-label">{{ $t('Male') }}</div>
          <b-img
              :src="require('@/assets/images/auth/male-avatar2.png')"
              alt="Male"
              class="gender-image"
              fluid
          />
        </div>
      </b-col>
    </b-row>

    <!-- Optional: Add a 'Next' button if you don't want immediate navigation on click -->
    <!--
    <b-button
      variant="primary"
      block
      class="mt-4"
      :disabled="!selectedGender"
      @click="goToNextStep"
    >
      {{ $t('Next') }}
    </b-button>
    -->
  </div>
</template>

<script>
import { BRow, BCol, BImg } from 'bootstrap-vue'

// Assuming you have female-avatar.png and male-avatar.png in the specified path
// You might need to create or rename your images accordingly.

export default {
  name: 'GenderSelection',
  components: {
    BRow,
    BCol,
    BImg,
    // BButton, // Uncomment if using the Next button
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    // backButton: String, // Probably not needed if this is the first step
  },
  data() {
    return {
      // Pre-select if user object already has gender, otherwise null
      selectedGender: this.user?.gender || null,
    }
  },
  methods: {
    selectGender(gender) {
      this.selectedGender = gender
      // Automatically navigate to the next step on selection
      this.goToNextStep()
    },
    goToNextStep() {
      if (!this.selectedGender) return // Don't proceed if nothing is selected

      // 1. Emit the updated user object with the gender
      this.$emit('updateUser', { ...this.user, gender: this.selectedGender })

      // 2. Set the back button target for the *next* screen
      // The back button on the next screen should lead back here.
      this.$emit('updateBackButton', 'GenderSelection')

      // 3. Navigate to the next component (e.g., PersonalInformation or SocialButtons)
      // Choose the appropriate next step in your flow
      this.$emit('updateActiveComponent', 'PersonalInformation')
      // Or maybe: this.$emit('updateActiveComponent', 'SocialButtons');
    },
  },
  // Basic i18n setup for demonstration
  i18n: {
    messages: {
      en: {
        Gender: 'Gender',
        'Please select your gender': 'Please select your gender',
        Next: 'Next',
      },
      tr: {
        Gender: 'Cinsiyet',
        'Please select your gender': 'Lütfen cinsiyetinizi seçin',
        Next: 'İleri',
      },
    },
  },
}
</script>

<style scoped lang="scss">
.gender-selection-container {
  width: 100%;
  max-width: 450px; // Limit width for better appearance
  margin: 0 auto;
}

.title {
  // Match the style from the image if possible
  font-size: 1.5rem;
  color: #878787;
  font-weight: 500;
  margin-bottom: 16px;
}

.subtitle {
  color: #878787;
  font-size: 0.9rem;
}

.gender-option-col {
  padding: 0.5rem; // Add some spacing between columns
}

.gender-card {
  border: 3px solid transparent; // Base border
  border-radius: 12px;        // Rounded corners
  padding: 2.2rem 1rem 0 1rem;       // Padding inside the card
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.selected {
    border-color: #19E286;
    border-width: 3px;
    border-style: solid;
    border-image-slice: 1;
  }
}

.gender-label {
  font-weight: 600;
  margin-bottom: 1rem;
  color: #878787;
  font-size: 13px;
  text-align: center;
  position: absolute;
  top: 12px;
  z-index: 999;
  padding: 0 12px;
}

.gender-image {
  max-width: 100px; // Control image size
  height: auto;    // Maintain aspect ratio
}
</style>